<template>
  <div class="account">
    <div class="accounttop">
      <!-- <div class="accountname">{{$t('datalogger.Datalogger_List')}}</div> -->
      <ul class="status-container">
        <li v-for="(value,key) in dataloggerStatus" :key="key" class="status">
          <span class="status-label">
            <i class="status-icon" :class="value.class"></i>
            {{value.label + ' : '}}
          </span>
          <span class="status-num">{{value.num}}</span>
        </li>
      </ul>
    </div>
    <div class="search">
      <el-select
        v-model="search.status"
        clearable
        @change="getDataloggerList(true)"
        :placeholder="this.$t('datalogger.Datalogger_Status')"
        popper-class="select-search"
      >
        <el-option
          v-for="(value,key) in status"
          :key="key"
          :value="key"
          :label="value.label"
          style="display:flex;padding-left:40px;align-items:center;"
        >
          <i style="width:10px;height:10px;margin-right:8px;" :class="`status-${value.name}`"></i>
          <span class="select-label">{{value.label}}</span>
        </el-option>
      </el-select>
      <el-input
        v-model.trim="search.alias"
        :placeholder="this.$t('datalogger.Datalogger_Name')"
        @keyup.enter.native="getDataloggerList(true)"
        clearable
      ></el-input>
      <el-input
        v-model.trim="search.pn"
        @keyup.enter.native="getDataloggerList(true)"
        :placeholder="this.$t('datalogger.Datalogger_PN')"
        clearable
      ></el-input>
      <button class="button-solid button" @click="getDataloggerList(true)"><i class="el-icon-search"></i></button>
      <button
        class="buttonClass"
        style="float: right;margin-right:10px;"
        :class="pagination.total ? 'button-solid' : 'button-disable'"
        @click="exportPlant('all')"
      >{{$t('report.all_reports')}}</button>
      <button
        style="float: right;margin-right:10px;"
        class="buttonClass"
        :class="selectedplant.length ? 'button-solid' : 'button-disable'"
        @click="exportPlant(selectedplant)"
      >{{$t('report.Batch_export')}}</button>
      <button
        style="float: right;margin-right:10px;"
        ref="UserRole"
        class="buttonClass button-solid"
        @click="dialogDataloggerVisible=true"
      >{{$t('datalogger.add_datalogger')}}</button>
    </div>
    <div class="sections">
      <!-- <div class="title">{{$t('datalogger.Datalogger_List')}}</div> -->
      <div class="table">
        <el-table
          :data="dataloggerList"
          border
          stripe
          height="100%"
          :row-style="{height:0}"
          :cell-style="{padding:0}"
          :header-cell-style="{background:'#F2F5F7',color:'#606266'}"
          v-loading="loadingDatalogger"
          element-loading-spinner="el-icon-loading"
          @selection-change="changeFun"
        >
          <el-table-column fixed type="selection"></el-table-column>
          <el-table-column
            min-width="140px;"
            fixed
            :show-overflow-tooltip="true"
            :label="this.$t('datalogger.Datalogger_Name')"
          >
            <template slot-scope="scope">
              <span
                class="redirect"
                @click="previewDatalogger(scope.row)"
                :title="scope.row.alias||scope.row.pn"
              >{{scope.row.alias||scope.row.pn}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="pn"
            min-width="135px;"
            :show-overflow-tooltip="true"
            :label="this.$t('datalogger.Datalogger_PN')"
          ></el-table-column>
          <!-- <el-table-column
            :show-overflow-tooltip="true"
            :label="$t('account.activeStatus')"
          >
            <template slot-scope="scope">
              <span :class="scope.row.active.class">
                {{scope.row.active.label}}
              </span>
            </template>
          </el-table-column>-->
          <el-table-column
            prop="status"
            min-width="80px;"
            :show-overflow-tooltip="true"
            :label="this.$t('datalogger.Status')"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.status!==undefined&&status[scope.row.status]"
                :class="`color-${status[scope.row.status].name}`"
              >{{status[scope.row.status].label}}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="120px;"
            :show-overflow-tooltip="true"
            :label="this.$t('datalogger.usr_belong')"
          >
            <template slot-scope="scope">
              <span :title="scope.row.usr||'--'">{{scope.row.usr||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="descx"
            min-width="135px;"
            :show-overflow-tooltip="true"
            :label="this.$t('datalogger.Datalogger_type')"
          >
            <!-- <template slot-scope="scope">
              <span :class="scope.row.enable.class">
                {{scope.row.enable.label}}
              </span>
            </template>-->
          </el-table-column>
          <el-table-column
            prop="balance"
            min-width="185px;"
            :show-overflow-tooltip="true"
            :label="this.$t('datalogger.Communication_balance')"
          ></el-table-column>
          <el-table-column
            prop="load"
            min-width="70px;"
            :show-overflow-tooltip="true"
            :label="this.$t('datalogger.load')"
          ></el-table-column>
          <el-table-column
            min-width="145px;"
            :show-overflow-tooltip="true"
            :label="this.$t('datalogger.Firmware_Version')"
          >
            <template slot-scope="scope">
              <span :title="scope.row.fireware||'--'">{{scope.row.fireware||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="signal"
            width="85px;"
            :show-overflow-tooltip="true"
            :label="this.$t('datalogger.signal')"
          >
            <template slot-scope="scope">
              <signal :strength="scope.row.signal"></signal>
            </template>
          </el-table-column>
          <el-table-column
            min-width="125px;"
            :show-overflow-tooltip="true"
            :label="this.$t('datalogger.administrator')"
          >
            <template slot-scope="scope">
              <span :title="scope.row.dist||'--'">{{scope.row.dist||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="this.$t('datalogger.Operation')" width="200">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="operation"
                :title="$t('datalogger.edit')"
                @click="editDatalogger(scope.row.pn)"
              >
                <i class="iconfont icon-edit1"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('datalogger.debug')"
                @click="debugDatalogger(scope.row.pn)"
              >
                <i class="iconfont icon-tiaoshi"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('datalogger.upgrade')"
                @click="upgradeDatalogger(scope.row)"
              >
                <i class="iconfont icon-upgrade"></i>
              </el-button>
              <!-- 导出单个报表按钮 -->
              <el-button
                type="text"
                class="operation"
                :title="$t('report.Export_report')"
                @click="exportPlant([scope.row])"
              >
                <i class="iconfont icon-export"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('datalogger.delete')"
                @click="deleteDatalogger(scope.row.pn)"
              >
                <i class="iconfont icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>
          <div v-show="emptyText" slot="empty">
            <img src="@/assets/img/empty_text.png" />
            <div style="line-height: 32px">{{$t('account.nodata')}}</div>
          </div>
        </el-table>
      </div>
      <div class="tablebottom">
        <el-pagination
          class="pagination"
          v-show="paginationControl"
          background
          @size-change="getDataloggerList(true)"
          @current-change="()=>getDataloggerList()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10,15,20,30,50]"
          :page-size.sync="pagination.pagesize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
      <export-plant-dialog :params.sync="exportPlantParams"></export-plant-dialog>
      <!-- 调试数采器 -->
      <control-dialog
        :title="$t('datalogger.datalogger_debug')"
        width="30vw"
        v-if="debugingDataloggerId"
        :visible.sync="debugingDataloggerId"
      >
        <div slot="content">
          <el-form class="grid">
            <el-form-item :label="$t('datalogger.communication_address')" size="small">
              <el-input type="number" v-model="datalogger.devaddr" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('datalogger.Instruction')" size="small">
              <el-input
                v-model="devDebug.cmd"
                :placeholder="$t('datalogger.such_as')"
                type="textarea"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('datalogger.return_content')" size="small">
              <el-input readonly v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <button class="button-hollow" @click="qingkong()">{{$t('datalogger.clear_data')}}</button>
          <button
            class="button-solid"
            type="primary"
            @click="submitDebugDatalogger()"
          >{{$t('datalogger.send')}}</button>
        </div>
      </control-dialog>
      <!-- 固件升级 -->
      <control-dialog
        :title="$t('datalogger.device_upgrade')"
        v-if="upgradeDataloggerVisible"
        :visible.sync="upgradeDataloggerVisible"
        width="580px"
      >
        <div slot="content">
          <el-form class="grid upload-container">
            <el-form-item :label="$t('datalogger.select_firmware')" size="small">
              <el-select v-model="searchrecharge" @change="voltageArr($event)" :placeholder="$t('datalogger.select_file')">
                <el-option
                  v-for="item in rechargelist"
                  :key="item.value"
                  :label="item.firmware"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" ">
              <div class="processstatue" v-show="progressUp">{{$t('firmware.upgrading')}}</div>
              <div
                class="processstatue"
                v-show="progerssComplete"
              >{{$t('firmware.updateCompleted')}}</div>
              <div class="upload-contents">
                <button class="upload-button" @click.prevent="$refs.fileUploader.click()">
                  <i class="iconfont icon-shangchuan"></i>
                  {{$t('datalogger.Upload')}}
                </button>
                <div class="upload-tip">{{$t('firmware.limit0')}}</div>
              </div>
              <div class="progressShow" v-show="progressUp">
                <div class="progressName">
                  <i class="iconfont icon-fujian"></i>
                  {{firmwareName}}
                </div>
                <div class="progressCancel" @click="upgradeCancel">
                  <i class="iconfont icon-delete"></i>
                </div>
              </div>
              <div class="processData" v-show="progressUp">
                <el-progress :format="progressText" :percentage="progress" :stroke-width="10"></el-progress>
                <div class="processBig">{{uploadNowSize}}M / {{uploadTotalSize}}M</div>
              </div>
              <input
                type="file"
                class="upload-input"
                ref="fileUploader"
                accept="application/octet-stream"
                @change="uploadfile($event)"
              />
              <div class="progerssComplete" v-show="progerssComplete">
                <div class="progressName">
                  <i class="iconfont icon-fujian"></i>
                  {{firmwareName}}
                </div>
                <div class="progressCancel" @click="upgradeDataloggerVisible"></div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <!-- <button
            class="button-hollow"
            @click="upgradeDataloggerVisible = false"
          >{{$t('datalogger.cancel')}}</button>-->
          <button class="button-solid" @click="submitUpgradeDatalogger">{{$t('datalogger.confirm')}}</button>
        </div>
      </control-dialog>
      <!-- 删除设备 去掉弹框的heard不加title=""和footer noFooter -->
      <control-dialog
        :visible.sync="deletingDataloggerId"
        v-if="deletingDataloggerId"
        width="30vw"
        noFooter
      >
        <div class="content_tishi" slot="content">
          <div class="tital">
            <i class="iconfont icon-gantanhao"></i>
            <span class="contentdelete">{{$t('datalogger.confirm_deldte')}}</span>
          </div>
          <div class="disabledescr">{{$t('account.notRecovered')}}</div>
          <!-- <span class="contentdelete">{{$t('datalogger.confirm_deldte')}}</span> -->
          <div class="deletfotter">
            <button
              class="button-solid"
              @click="submitDeleteDatalogger"
            >{{$t('datalogger.confirm')}}</button>
            <button
              class="button-hollow"
              @click="deletingDataloggerId = null"
            >{{$t('datalogger.cancel')}}</button>
          </div>
        </div>
      </control-dialog>
      <!-- 导出所有报表按钮 -->
      <!-- <div class="section-bottom">
      <button :class="selectedplant.length ? 'button-solid' : 'button-disable'" @click="exportPlant(selectedplant)">批量导出</button> 
      <button :class="pagination.total ? 'button-solid' : 'button-disable'" @click="exportPlant('all')">导出所有</button> 
        <el-pagination
        class="pagination"
        background
        @size-change="getDataloggerList(true)"
        @current-change="()=>getDataloggerList()"
        :current-page.sync="pagination.currentPage"
        :page-sizes="[10,20,30,50]"
        :page-size.sync="pagination.pagesize"
        layout="total, prev, pager, next, sizes, jumper"
        :total="pagination.total"
        ></el-pagination>
      </div>-->
      <!-- 数采器对应设备表弹窗 -->
      <control-dialog
        :title="previewDataloggerInfo.alias"
        :visible.sync="previewDataloggerInfo"
        v-if="previewDataloggerInfo"
        width="75vw"
        height="50vh"
      >
        <el-table
          slot="content"
          :data="previewDeviceList"
          stripe
          border
          height="100%"
          :empty-text="$t('errCode.258')"
          v-loading="loadingPreviewDevice"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column :show-overflow-tooltip="true" :label="$t('device.device_name')">
            <template slot-scope="scope">
              <span
                class="redirect"
                @click="enterDevice(scope.row)"
                :title="scope.row.devalias||scope.row.sn"
              >{{scope.row.devalias||scope.row.sn}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sn" :show-overflow-tooltip="true" :label="$t('device.device_sn')"></el-table-column>
          <el-table-column
            prop="status"
            :show-overflow-tooltip="true"
            :label="$t('device.device_status')"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.status!==undefined"
                :class="`color-${$filter.deviceStatus[scope.row.status].name}`"
              >{{$filter.deviceStatus[scope.row.status].label}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="brand"
            :show-overflow-tooltip="true"
            :label="$t('device.device_type')"
          >
            <template slot-scope="scope">{{scope.row.brand | translateDeviceType}}</template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" :label="$t('device.device_model')">
            <template slot-scope="scope">
              <span :title="scope.row.devtype||'--'">{{scope.row.devtype||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" :label="$t('device.User_belong')">
            <template slot-scope="scope">
              <span :title="scope.row.usr||'--'">{{scope.row.usr||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="devaddr"
            :show-overflow-tooltip="true"
            :label="$t('device.device_address')"
          ></el-table-column>
          <el-table-column
            prop="devcode"
            :show-overflow-tooltip="true"
            :label="$t('device.device_code')"
          ></el-table-column>
        </el-table>
      </control-dialog>
    </div>
    <!-- 新增数采器 -->
    <datalogger-dialog
      :visible.sync="dialogDataloggerVisible"
      @submitSuc="handleAddSuc"
      v-if="dialogDataloggerVisible"
    ></datalogger-dialog>
    <!--修改数采器-->
    <datalogger-dialog
      :editing="editingInfo"
      :visible.sync="editingInfo"
      @submitSuc="handleEditSuc"
      v-if="editingInfo"
    ></datalogger-dialog>
  </div>
</template>
<script>
import dataloggerDialog from "@/components/dialog/datalogger";
import controlDialog from "@/components/dialog";
import signal from "@/components/signal";
import exportPlantDialog from "@/components/dialog/exportPlant";
export default {
  components: {
    dataloggerDialog,
    controlDialog,
    signal,
    exportPlantDialog
  },
  data() {
    return {
      emptyText: false,
      progress: 0,
      firmwareName: "",
      dialogDataloggerVisible: false, // 是否显示新增数采器弹窗
      selectedplant: [], //勾选数采器导出

      search: {
        status: "",
        alias: "",
        pn: ""
      },
      dataloggerStatus: {
        onLineCount: {
          num: 0,
          label: this.$t("statistic.normal"),
          class: "status-normal"
        },
        offLineCount: {
          num: 0,
          label: this.$t("statistic.offline"),
          class: "status-offline"
        }
      },
      status: {
        0: {
          num: 0,
          label: this.$t("datalogger.Normal"),
          name: "normal"
        },
        1: {
          num: 0,
          label: this.$t("datalogger.Offline"),
          name: "offline"
        }
      },
      paginationControl: false,
      file: null, //保存上传文件流的容器
      progressUp: false,
      progerssComplete: false,
      uploadNowSize: "0.00", //现在正在上传的大小
      uploadTotalSize: "", //文件的总大小
      paramass: "", //中间变量
      searchrecharge: "",
      searchrechargeContents: "",
      dataparams: "",
      rechargelist: [],
      loadingDatalogger: false,
      loadingPreviewDevice: false, // 正在加载数采器对应设备表
      isLoading: false,
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      dataloggerList: [],
      editingInfo: null, // 正在修改的数采器信息
      debugingDataloggerId: null, // 调试的数采器id
      upgradeDataloggerVisible: false, // 固件升级弹窗可见性
      deletingDataloggerId: null, // 删除的数采器id
      previewDataloggerInfo: null, // 查看的数采器
      previewDeviceList: [], // 查看的数采器对应设备表
      exportPlantParams: [], //导出报表
      formEdit: {
        pn: "",
        alias: ""
      },
      datalogger: {
        devaddr: ""
      },
      devDebug: {
        cmd: ""
      },
      debugReturn: ""
    };
  },
  watch: {
    // 响应更新电站列表事件
    "$store.state.event.updateDataloggerList"(val) {
      if (val) {
        this.getDataloggerList();
        this.$store.state.event.updateDataloggerList = false;
      }
    },
    upgradeDataloggerVisible(val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
      }
    }
  },
  created() {
    this.queryDataloggerStatus();
    this.getDataloggerList();
  },
  mounted() {
    if (this.$store.state.user.role == 2) {
      this.$refs.UserRole.style.visibility = "visible";
    } else {
      this.$refs.UserRole.style.visibility = "hidden";
    }
  },
  methods: {
    // 查询数采器状态
    queryDataloggerStatus() {
      let param = {
        devtype: 2304
      };
      this.$request.get("queryCollectorCountEs", param).then(res => {
        if (res.err === 0) {
          for (let key in this.dataloggerStatus) {
            this.dataloggerStatus[key].num = res.dat[key];
          }
        }
      });
    },
    progressText(progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },

    //勾选多项
    changeFun(val) {
      this.selectedplant = val; // 返回的是选中的列的数组集合
    },
    // 导出报表
    exportPlant(exportPlantParams) {
      if (!exportPlantParams.length) return false;
      this.exportPlantParams = exportPlantParams;
    },
    // 查询设备列表
    getDataloggerList(reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        // alias:this.search.pn,
        // pn:this.search.pn,
        ...this.search,
        devtype: 2304,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize
      };
      this.loadingDatalogger = true;
      this.$request.get("webQueryCollectorsEs", param).then(res => {
        if (res.err === 0) {
          this.dataloggerList = res.dat.collector;
          this.pagination.total = res.dat.total;
          if (this.pagination.total > this.pagination.pagesize) {
            this.paginationControl = true;
          }
        }
        // else if(res.err === 257 && this.search.alias && !this.search.pn) {
        //   this.search.pn = this.search.alias
        //   this.search.alias = ''
        //   this.getDataloggerList()
        // }
        else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.dataloggerList = [];
          this.pagination.total = 0;
        }
        this.loadingDatalogger = false;
      });
    },
    // 查看数采器对应设备
    previewDatalogger(info) {
      this.previewDataloggerInfo = {
        pn: info.pn,
        alias: info.alias || info.pn
      };
      let param = {
        pn: info.pn,
        devtype: 2304,
        page: 0,
        pagesize: 50
      };
      this.loadingPreviewDevice = true;
      this.$request.get("webQueryDeviceEs", param).then(res => {
        if (res.err === 0) {
          this.previewDeviceList = res.dat.device;
        } else {
          this.previewDeviceList = [];
        }
        this.loadingPreviewDevice = false;
      });
    },
    // 点击进入设备
    enterDevice(info) {
      if (!info.uid) {
        this.$message.error(this.$t(`device.noAuth`));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then(res => {
          if (res.err === 0) {
            let routeUrl = this.$router.resolve({
              // path: "/general/home",
              path: "/generalNew/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
                devcode: info.devcode,
                pn: info.pn,
                devaddr: info.devaddr,
                sn: info.sn
              }
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 修改数采器
    editDatalogger(pn) {
      this.$request.get("queryCollectorinfoEs", { pn }).then(res => {
        if (res.err === 0) {
          this.editingInfo = { pn, ...res.dat };
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 修改数采器成功回调
    handleEditSuc() {
      this.$message.success(this.$t("datalogger.modifySuc"));
      this.getDataloggerList();
    },
    // 调试数采器
    debugDatalogger(pn) {
      this.devDebug.cmd = null;
      this.debugReturn = null;
      this.debugingDataloggerId = pn;
      this.$request
        .get("queryCollectorInfo", {
          pn: this.debugingDataloggerId
        })
        .then(res => {
          if (res.err === 0) {
            // this.debugInverterVisible = true,
            this.datalogger = res.dat.collector[0];
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 调试清空
    qingkong() {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 发送指令
    submitDebugDatalogger() {
      if (this.datalogger.devaddr == null) {
        this.$message.error(this.$t("datalogger.devaddrfail"));
      } else if (this.datalogger.status == "1") {
        this.$message.error(this.$t("datalogger.Debugfail"));
      } else {
        this.debugReturn = this.$t("datalogger.instruction_response");
        let param = {
          pn: this.datalogger.pn,
          devaddr: this.datalogger.devaddr,
          cmd: this.devDebug.cmd
        };
        this.$request.get("sendCmdToDevice", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("datalogger.debug_suc"));
            this.debugReturn = res.dat.dat;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    voltageArr(item){
     this.rechargelist.forEach(element => {
       if(element.id == item){
         this.searchrechargeContents = element
       }
     });
    },
    // 数采器固件升级
    upgradeDatalogger(info) {
      this.queryFirmware();
      this.dataparams = info;
      this.upgradeDataloggerVisible = true;
      this.progerssComplete = false;
    },
    // 查询固件列表
    queryFirmware() {
      this.searchrecharge = null;
      this.rechargelist = [];
      this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", { pagesize: 50 }).then(res => {
        if (res.code == 0) {
          res.data.items.forEach(item => {
            this.rechargelist.push({
              id: item.id,
              firmware: item.firmware,
              size: item.size
            });
          });
        }
      });
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile(event) {
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
      });
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("datalogger.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex"&& suffix !== "S19") {
        this.$message.error(this.$t("datalogger.error1"));
        return;
      }
      this.$request.uploadfileAxios(file).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t("datalogger.uploadSuccess"));
        } else if (res.code === 6) {
          this.$message.error(this.$t("datalogger.error1"));
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          this.$message.error(res.message);
        }
        this.queryFirmware();
      });
    },
    // 确认固件升级
    submitUpgradeDatalogger() {
      this.progress = 0;
      if (!this.searchrecharge) {
        this.$message.error(this.$t("datalogger.file_fist"));
      } else if (this.dataparams.status == "1") {
        this.$message.error(this.$t("datalogger.updatefail"));
      } else {
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        let params = {
          pn: this.dataparams.pn,
          firmwareId: this.searchrecharge
        };
        this.$request.postUPG("/upg/api/auth/web/shineDess/collector/firmwareUpgradeCollector", params).then(res => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              // this.$message.success(this.$t("datalogger.update_suc"));
              this.$message.success(this.$t("device.Upgrading"));
              this.queryProgress();
              // this.upgradeDataloggerVisible = false;
            } else if (res.data.ret == 1) {
              this.$message.error(this.$t("device.System_Failed"));
            } else if (res.data.ret == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
            } else if (res.data.ret == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
            }
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
          }
        });
      }
    },
    // 查询升级进度
    queryProgress() {
      this.progressUp = true;
      this.progerssComplete = false;
      let params = {
        pn: this.dataparams.pn,
        // devaddr: this.dataparams.devaddr,
        // devcode: this.dataparams.devcode,
        // sn: this.dataparams.sn,
        key: this.keyProgress
      };
      this.interval = setInterval(() => {
        this.$request.getUPG("/upg/api/auth/web/shineDess/collector/queryCollectorFirmwareUpgradeProgress", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                // this.progressText = progress + "%";
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  clearInterval(this.interval);
                  this.interval = null;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.$message.success(this.$t("device.Update_Completed"));
                  setTimeout(() => {
                    this.upgradeDataloggerVisible = false;
                  }, 3000);
                  return;
                }
              } else if (res.data.status == 1) {
                this.$message.error(this.$t("firmware.upgrade_quit1"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDataloggerVisible = false;
                return;
              } else if (res.data.status == 2) {
                this.$message.error(this.$t("firmware.upgrade_quit2"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDataloggerVisible = false;
                return;
              } else if (res.data.status == 3) {
                this.$message.error(this.$t("firmware.upgrade_quit3"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDataloggerVisible = false;
                return;
              } else if (res.data.status == 4) {
                this.$message.error(this.$t("firmware.upgrade_quit4"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDataloggerVisible = false;
                return;
              } else if (res.data.status == 5) {
                this.$message.error(this.$t("firmware.upgrade_quit5"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDataloggerVisible = false;
                return;
              }
            } else {
              // this.$message.error(this.$t(`errCode.${res.code}`));
              this.$message.error(res.message);
              clearInterval(this.interval);
              this.interval = null;
            }
          });
      }, 2000);
    },
    //取消升级
    upgradeCancel() {
      this.$request.putUPG("/upg/api/auth/web/shineDess/collector/collectorCancelFirmwareUpgrade", {
          pn: this.dataparams.pn,
          key: this.keyProgress
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDataloggerVisible = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        });
    },
    //删除数采器
    deleteDatalogger(pn) {
      this.deletingDataloggerId = pn;
    },
    // 确定删除数采器
    submitDeleteDatalogger() {
      this.$request
        .get("delCollectorFromPlant", { pn: this.deletingDataloggerId })
        .then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("datalogger.deleteSuc"));
            this.deletingDataloggerId = null;
            this.getDataloggerList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 新增数采器成功回调
    handleAddSuc() {
      this.$message.success(this.$t("datalogger.add_suc"));
      this.getDataloggerList();
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");
.account {
  background-color: #fff;
  margin: 10px;
  // margin: 24px 24px 50px 24px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  .accounttop {
    // display: flex;
    // flex-direction: row;
    // justify-content: space-between;
    padding: 15px 24px 0;
    align-self: flex-end;
    // .accountname {
    //   font-size: 16px;
    //   font-weight: bold;
    //   color: #333;
    //   letter-spacing: 1.5px;
    // }
    .accountstatue {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      .statuename {
        text-align: center;
        width: 130px;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
        margin-left: 15px;
      }
      .normal {
        border: 1px solid @normalColor;
      }
      .offline {
        border: 1px solid @offlineColor;
      }
      .warning {
        border: 1px solid @warningColor;
      }
      .fault {
        border: 1px solid @faultColor;
      }
      .standby {
        border: 1px solid @standbyColor;
      }
    }
  }
  .search {
    .button-create {
      float: right;
    }
  }
  .sections {
    margin: 0 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .table {
      flex: 1;
      overflow: auto;
    /deep/.el-icon-loading{
       font-size: 28px;
      }
    }
    .tablebottom {
      align-self: flex-end;
      // text-align: center;
      margin-bottom: 10px;
    }

    .current-value {
      display: flex;
      .el-input {
        flex: 1;
        margin-right: 3px;
      }
      .submit-control {
        i {
          font-size: 18px;
        }
        padding: 5px 12px;
      }
    }
    .control-value {
      .submit-control {
        i {
          font-size: 18px;
        }
      }
    }
    .control {
      height: 50vh;
    }
  }
  .active {
    color: #26ae3c;
  }
  .inactive {
    color: #c9c9c9;
  }
  .upload-input {
    display: none;
  }
  // .section-bottom {
  //   margin-top: 20px;
  //   align-items: center;
  //   justify-self: flex-end;
  //   display: flex;
  //   justify-content: space-between;
  //   button {
  //     height: 31px;
  //     padding: 0 25px;
  //   }
  //   .pagination {
  //     margin-top: 0;
  //     align-self: flex-end;
  //   }
  // }

  .contentdelete {
    font-size: 20px;
    font-weight: 600;
  }
  .deletfotter {
    margin-top: 50px;
    .button-hollow {
      width: 100px;
      height: 40px;
      margin-right: 40px;
    }
    .button-solid {
      width: 100px;
      height: 40px;
    }
  }
  .status-container {
    display: flex;
    align-items: center;
    .status {
      border-radius: 25px;
      box-shadow: 0px -1px 2.5px #7f7f7f;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 10px;
      padding: 0px 20px;
      height: 32px;
      line-height: 32px;
      background-color: #fff;
      // border: 1px solid #000;
      border-radius: 18px;
      box-shadow: inset 0px 0px 5px 1px #ccc;
      &-num {
        color: #333;
        font-size: 14px;
      }
      &-label {
        color: #333;
        font-size: 14px;
      }
      &-icon {
        width: 10px;
        height: 10px;
        margin-right: 3px;
      }
    }
  }
}
</style>
